/**
 * @voltxampere/engine — Worker state container (Sprint 9)
 *
 * Module-scoped mutable state the worker handler reads and
 * updates. The only reason this is a class instead of bare
 * `let`s is testability: the `makeWorkerState` factory can be
 * invoked from jsdom tests to obtain an isolated instance.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export function makeWorkerState() {
    return {
        circuit: null,
        initialised: false,
        lastDc: null,
        lastTransient: null,
        lastAc: null,
        pendingCancellations: new Map(),
        stream: null,
    };
}
//# sourceMappingURL=state.js.map